import React from 'react'
import { CashPayment } from './cash-payment'
import { InstallmentPayment } from './index'

export const NegotiationPayment = () => {
  // Dados de parcelas salvos no localStorage (para pagamento parcelado)
  const installmentsCountFromStorage = localStorage.getItem('negotiation_installments_count')
  const installmentValueFromStorage = localStorage.getItem('negotiation_installment_value')

  // Verificar quantidade de parcelas do localStorage
  const installmentsCountFromStorageParsed = installmentsCountFromStorage ? parseInt(installmentsCountFromStorage, 10) : 0

  // Lógica simplificada: usar APENAS localStorage para detectar tipo de pagamento
  // Esta lógica é baseada no fato de que:
  // - Para pagamento parcelado: dados de parcelas são salvos em hooks.js (handleSign) quando installmentNumber > 0
  // - Para pagamento à vista: dados de parcelas são removidos em simulation/index.js antes do redirecionamento
  //
  // Se houver dados de parcelas no localStorage (count > 0 OU value não nulo), é pagamento parcelado
  // Caso contrário, é pagamento à vista
  const hasInstallmentDataInStorage =
    installmentsCountFromStorageParsed > 0 || (installmentValueFromStorage !== null && installmentValueFromStorage !== '')

  const isCashPayment = !hasInstallmentDataInStorage

  return isCashPayment ? <CashPayment /> : <InstallmentPayment />
}
